export default "__VITE_ASSET__D82_YkcH__"